import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

import { AffiliateService } from '@www-src/app/core/affiliate.service';

@Component({
  selector: 'app-affiliate',
  standalone: true,
  imports: [CommonModule, TranslateModule, AsyncPipe, RouterLink, NgIf],
  templateUrl: './affiliate.component.html',
  styleUrls: ['./affiliate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AffiliateComponent {
  private affiliateService = inject(AffiliateService);
  public isAffiliateBannerShown$: BehaviorSubject<boolean> = this.affiliateService.isAffiliateBannerShown$;
  public affiliateName$ = this.affiliateService.affiliateName$;

  public onGetStarted(): void {
    this.affiliateService.setAffiliateBannerOpen(false);
    this.affiliateService.redirectToAccount();
  }

  public onCloseBanner(): void {
    this.affiliateService.setAffiliateBannerOpen(false);
  }
}
